import React from "react";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { SERVER_BASE_URL } from "../constants";

const ImageCarousel = (props) => (
  <Carousel>
    {
      props.images.map(i => {
        return (
          <div>
            <img alt="#" src={`${SERVER_BASE_URL}${i.image}`} />
          </div>
        );
      })
    }
  </Carousel>
);

export default ImageCarousel;
